import { Injectable } from "@angular/core";
import {Subject } from "rxjs";
import { IdbNotificationsResponse } from "src/app/model/idb";
import { BaseResponse } from "src/app/model/response/base-response";
import { IdbService } from "src/app/services/idb.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { environment } from "src/environments/environment";
import { NotificationModel } from "./notifications";

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {

  public updateNotificationsSubject$: Subject<number> = new Subject<number>();

  constructor(private idb:IdbService, private localStorageS: LocalStorageService){}


  getNotificationsToRead():number{
    //write the idb query and filter by sessionid
    let userData = this.localStorageS.getUserData();
    let num = 0;
    this.idb.getAllData(environment.idbTables.Notifications).then((data:IdbNotificationsResponse[])=>{

      num = data.filter(x=> x.item.userId == userData?.id && x.item.viewed == false).length;
      this.updateNotificationsSubject$.next(num);
      return num;
    })

    return num;

  }

  getAllNotifications(): NotificationModel[]{
    let userData = this.localStorageS.getUserData();
    let returnList: NotificationModel[] = []
    this.idb.getAllData(environment.idbTables.Notifications).then((data:IdbNotificationsResponse[])=>{

      data.filter(x=> x.item.userId == userData?.id).forEach(notif=>{
        console.warn(notif)
        returnList.push(notif.item);
      });

      return returnList;
      
    })
    return returnList;
  }

  writeNotification(resp: BaseResponse){
    let userData = this.localStorageS.getUserData();
    this.idb.getAllData(environment.idbTables.Notifications).then((data:IdbNotificationsResponse[])=>{
    
      let notif: NotificationModel = {
        content: resp.error,
        title: resp.error,
        location: '',
        date: Date.now().toString(),
        userId: userData!.id,
        viewed: false,
        severity: resp.success ? 'success' : 'error'
      }


      this.idb.addItemRow(environment.idbTables.Notifications,notif,`${data.length + 1}`);

      this.updateNotificationsSubject$.next(data.filter(x=> x.item.userId == userData?.id && x.item.viewed == false).length + 1);
    })
  }

  writeNotificationApp(resp: NotificationModel){
    let userData = this.localStorageS.getUserData();
    this.idb.getAllData(environment.idbTables.Notifications).then((data:IdbNotificationsResponse[])=>{
    
      

      this.idb.addItemRow(environment.idbTables.Notifications,resp,`${data.length + 1}`);

      this.updateNotificationsSubject$.next(data.filter(x=> x.item.userId == userData?.id && x.item.viewed == false).length + 1);
    })
  }

  markAsViewedNotifications(){
    let userData = this.localStorageS.getUserData();
    this.idb.getAllData(environment.idbTables.Notifications).then((data:IdbNotificationsResponse[])=>{

      let notifs = data.filter(x=> x.item.userId == userData?.id);

      notifs.forEach(not=>{
        not.item.viewed = true;

        this.idb.addItemRow(environment.idbTables.Notifications,not.item,not.code);
      })


      this.updateNotificationsSubject$.next(data.filter(x=> x.item.userId == userData?.id && x.item.viewed == false).length);
    
    })
  }
}
